import { SchemaDatapointEnumOption } from '@rossum/api-client/schemas';

export const optionsToHash = (options: SchemaDatapointEnumOption[]) => {
  return JSON.stringify(
    Object.fromEntries(options.map(o => [o.value, o.label]))
  );
};
